import { createContext } from 'react'

const payGccContext = createContext()

export default payGccContext
